import * as React from 'react';
import * as classNames from 'classnames';
import {StatelessComponent} from 'react';
import {Link} from 'react-router-dom';
import './styles.sass';

export interface IAuthLinkProps {
  children?: any;
  purple?: boolean;
  small?: boolean;
  url?: string;
}

export const AuthLink: StatelessComponent<IAuthLinkProps> = ({children, small, purple, url}) => (
  <Link
    className={
      classNames('auth-link', {'auth-link_small': small, 'auth-link_purple': purple})
    }
    to={url}
  >
    {children}
  </Link>
);
